import { useCallback, useEffect, useState, useRef } from "react";
import { SENSITIVE_FIELDS, CARDFIELDMAP } from "@icoach/components/creditCard/creditCard.config";
import { isEmpty, isEqual } from "@util/utils";

const useCreditCardState = defaultValue => {
	const [creditCardInfo, setCreditCardInfo] = useState({
		cardExpiryDate: null,
		cardName: null,
		creditCardBankName: null,
		creditCardNo: null,
		creditCardType: null,
	});
	const hasClearedRef = useRef(false);
	const hasDefaultRef = useRef(defaultValue.creditCardNo || defaultValue.cardExpiryDate);

	const handleUpdateField = useCallback(
		(key, value) => {
			setCreditCardInfo(prev => {
				const nextState = {
					...prev,
					[key]: value,
				};

				const isSensitiveField = SENSITIVE_FIELDS.includes(key);

				// 只做一次清空，且有預設值時才執行
				if (isSensitiveField && hasDefaultRef.current && !hasClearedRef.current) {
					const otherField = isEqual(key, CARDFIELDMAP.CARDNO) ? CARDFIELDMAP.EXPIRYDATE : CARDFIELDMAP.CARDNO;

					// 只有當另一欄有預設值，才需要清空
					if (prev[otherField]) {
						nextState[otherField] = "";
						hasClearedRef.current = true;
					}
				}
				return nextState;
			});
		},
		// eslint-disable-next-line
		[],
	);

	const replaceCreditCardInfo = useCallback(
		(newInfo = {}) => {
			setCreditCardInfo(newInfo);
			hasClearedRef.current = false;
			hasDefaultRef.current = newInfo.creditCardNo || newInfo.cardExpiryDate;
		},
		// eslint-disable-next-line
		[],
	);

	const updateCreditCardType = useCallback(
		value => {
			setCreditCardInfo(prev => ({ ...prev, [CARDFIELDMAP.CARDTYPE]: value }));
		},
		// eslint-disable-next-line
		[],
	);

	useEffect(
		() => {
			if (!isEmpty(defaultValue)) {
				setCreditCardInfo(defaultValue);
			}
		},
		// eslint-disable-next-line
		[JSON.stringify(defaultValue)],
	);

	return { creditCardInfo, onUpdateField: handleUpdateField, onCreditCard: updateCreditCardType, replaceCreditCardInfo };
};

export default useCreditCardState;
